import { Injectable } from '@angular/core';
import { RestCallService } from '../../../../core/services/rest-call/rest-call.service';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { TranslateApplicationService } from '../../../../core/translate/translate-application-service';
import { IBulletin } from 'src/app/core/interfaces/IBulletin';
import { UserInfoService } from './user-info-service';
import { ISites } from '../interfaces/ISites';


@Injectable({
  providedIn: 'root'
})

export class SitesService extends RestCallService {
    public DataToSent:ISites = {
        pk_site: 0,
        site: "",
        code: "",
        company_name: "",
        creation_date: new Date(),
        str_creation_date: "",
        fk_employee_creator: 0,
        last_updated: new Date(),
        str_last_updated: "",
        fk_employee_updater: 0,
        available: false,
        employee_creator_name: "",
        employee_updater_name: "",
        username: "",
        fk_employee: 0,
        check: false,
        fk_building: 0,
        building: "",
        level: 0,
        fk_site: 0,
        pk_building: 0,
        fk_sitelogged_user: 0,
        time_zone: "",
        fk_language: 0,
    }

    constructor (public httpClient: HttpClient, public toastr: ToastrService, public notificationService: NotificationService, public translate: TranslateApplicationService,private userInfoService: UserInfoService) {
        super(httpClient, 'LockerLinkApi', toastr, notificationService, translate)
    }

    public GetSitesByUsername() {
		this.DataToSent.username = this.userInfoService.windowsNT;
		return this.post<ISites[]>( '/api/Sites/GetSitesByUsername', this.DataToSent);
	}

}